import * as THREE from 'three';
// The light conforms to real terrain height; it is not painted over the ball.
export class WarmLightView {
 constructor(world){
  const canvas=document.createElement('canvas');canvas.width=canvas.height=128;
  const c=canvas.getContext('2d'),g=c.createRadialGradient(64,64,7,64,64,62);
  g.addColorStop(0,'rgba(255,253,215,.84)');g.addColorStop(.58,'rgba(255,234,136,.50)');g.addColorStop(.90,'rgba(255,234,150,.26)');g.addColorStop(1,'rgba(255,235,155,0)');
  c.fillStyle=g;c.fillRect(0,0,128,128);
  const texture=new THREE.CanvasTexture(canvas);texture.colorSpace=THREE.SRGBColorSpace;
  this.geometry=new THREE.PlaneGeometry(2,2,16,16);
  this.mesh=new THREE.Mesh(this.geometry,new THREE.MeshBasicMaterial({map:texture,transparent:true,depthWrite:false,side:THREE.DoubleSide,toneMapped:false}));
  this.mesh.name='warm-light-ground';this.mesh.renderOrder=2;world.add(this.mesh);
  this.ring=new THREE.Line(new THREE.BufferGeometry().setFromPoints(Array.from({length:65},()=>new THREE.Vector3())),new THREE.LineBasicMaterial({color:'#fff5c3',transparent:true,depthWrite:false,toneMapped:false}));
  this.ring.name='warm-light-dwell';this.ring.renderOrder=3;world.add(this.ring);this.mesh.visible=this.ring.visible=false;
 }
 update(light,heightAt){
  this.mesh.visible=this.ring.visible=!!light&&light.alpha>.005;
  if(!this.mesh.visible)return;
  const p=this.geometry.attributes.position,uv=this.geometry.attributes.uv;
  for(let i=0;i<p.count;i++){const x=light.x+(uv.getX(i)*2-1)*light.radius,z=light.z+(uv.getY(i)*2-1)*light.radius;p.setXYZ(i,x,heightAt(x,z)+.026,z);}
  p.needsUpdate=true;this.geometry.computeBoundingSphere();this.mesh.material.opacity=light.alpha;
  const rp=this.ring.geometry.attributes.position;
  for(let i=0;i<65;i++){const a=i/64*Math.PI*2-Math.PI/2,x=light.x+Math.cos(a)*light.radius*.88,z=light.z+Math.sin(a)*light.radius*.88;rp.setXYZ(i,x,heightAt(x,z)+.03,z);}
  rp.needsUpdate=true;this.ring.geometry.computeBoundingSphere();this.ring.geometry.setDrawRange(0,Math.floor(light.progress*64)+1);this.ring.material.opacity=light.alpha*.9;
 }
}
export function drawWarmLightCanvas(c,project,heightAt,light){
 if(!light||light.alpha<=.005)return;
 const point=(angle,r)=>{const x=light.x+Math.cos(angle)*r,z=light.z+Math.sin(angle)*r;return project(x,heightAt(x,z)+.026,z);};
 c.save();
 for(let j=0;j<18;j++){
  const r=light.radius*(1-j/20);c.globalAlpha=light.alpha*(j===0?.16:.047);c.fillStyle=j<8?'#ffe591':'#fffdd7';c.beginPath();
  for(let i=0;i<=40;i++){const p=point(i/40*Math.PI*2,r);i?c.lineTo(p[0],p[1]):c.moveTo(p[0],p[1]);}c.closePath();c.fill();
 }
 if(light.progress>0){c.globalAlpha=light.alpha*.95;c.strokeStyle='#fff5c3';c.lineWidth=1.8;c.lineCap='round';c.beginPath();for(let i=0;i<=Math.floor(light.progress*64);i++){const p=point(i/64*Math.PI*2-Math.PI/2,light.radius*.88);i?c.lineTo(p[0],p[1]):c.moveTo(p[0],p[1]);}c.stroke();}
 c.restore();
}
